import { useState } from 'react';

import useToast from '~hooks/useToast';
import { MAX_REGISTERABLE_TRAVELERS } from '~constants/pointToPointTicket';

interface Props {
  currentTravelers?: number[];
  onApply: (travelers: number[], closeAfterApply?: boolean) => void;
}

const useTravelerOption = ({ currentTravelers, onApply }: Props) => {
  const [travelers, setTravelers] = useState<number[]>(currentTravelers ?? []);
  const [selectedTraveler, setSelectedTraveler] = useState<{ index: number; age: number } | null>(
    null,
  );
  const [viewSelectedTravelerAge, setViewSelectedTravelerAge] = useState(false);
  const toast = useToast({ position: 'bottom-center' });

  const handleApplyTravelers = ({
    updatedTravelers,
    closeAfterApply = true,
  }: {
    updatedTravelers?: number[];
    closeAfterApply?: boolean;
  }) => {
    onApply(updatedTravelers ?? travelers, closeAfterApply);
  };

  const handleChangeTravelerAge = (index: number, age: number) => {
    if (typeof travelers[index] === 'number') {
      setTravelers((prev) => prev.map((traveler, i) => (i === index ? age : traveler)));
      setSelectedTraveler(null);
    }
  };

  const handleDecreaseCount = () => {
    setTravelers(travelers.slice(0, travelers.length - 1));
  };

  const handleIncreaseCount = () => {
    if (travelers.length === MAX_REGISTERABLE_TRAVELERS) {
      toast.success({
        id: 'max-travelers',
        message: '최대 9명까지 예약 가능합니다.',
      });
      return;
    }

    setSelectedTraveler(null);
    setViewSelectedTravelerAge(true);
  };

  const handleIncreaseTraveler = (age: number) => {
    setTravelers([...travelers, age]);
    setViewSelectedTravelerAge(false);
  };

  const handleDecreaseTraveler = () => {
    setTravelers(travelers.slice(0, travelers.length - 1));
    setViewSelectedTravelerAge(false);
  };

  const handleResetCount = () => {
    setTravelers([]);
  };

  return {
    travelers,
    setTravelers,
    selectedTraveler,
    setSelectedTraveler,
    viewSelectedTravelerAge,
    setViewSelectedTravelerAge,
    handleApplyTravelers,
    handleChangeTravelerAge,
    handleDecreaseCount,
    handleIncreaseCount,
    handleIncreaseTraveler,
    handleDecreaseTraveler,
    handleResetCount,
  };
};

export default useTravelerOption;
